import { ComponentPropsWithoutRef } from 'react'
import style from './../subTitle.module.css'

interface Props {
    bold?: boolean
}

const SubTitle = ({ children, bold = false, ...rest }: Props & ComponentPropsWithoutRef<'div'>) => {
    return (
        <div
            {...rest}
            className={[style.subTitle, bold ? style.bold : '', rest.className].join(' ')}>
            {children}
        </div>
    )
}

export default SubTitle
